import React from "react";
import "./instructions.scss";
import { Col, Divider, List, Typography } from "antd";
import {
  BankOutlined,
  CloseOutlined,
  FileDoneOutlined,
  LaptopOutlined,
  MailOutlined,
  TrophyOutlined,
} from "@ant-design/icons";

interface InstructionsListData {
  title: string;
  icon: React.ReactNode;
}

const instructions: InstructionsListData[] = [
  {
    title: "Educational qualification",
    icon: <FileDoneOutlined />,
  },
  {
    title: "Work experience",
    icon: <BankOutlined />,
  },
  {
    title: "Technology proficiency",
    icon: <LaptopOutlined />,
  },
  {
    title: "Achievements and awards",
    icon: <TrophyOutlined />,
  },
];

const Instructions = () => {
  return (
    <div className="instructions">
      <div className="message_icon">
        <div className="head_container">
          <MailOutlined />
        </div>
      </div>
      <Typography.Title level={5} type="secondary" style={{ margin: 0 }}>
        Dont forget to add the following details on your CV
      </Typography.Title>
      <Divider />
      <List
        itemLayout="horizontal"
        size="small"
        dataSource={instructions}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta avatar={item.icon} title={item.title} />
          </List.Item>
        )}
      />
    </div>
  );
};

export default Instructions;
